/**
 * Pulls the 11-character video id out of any YouTube URL form — watch?v=,
 * youtu.be/, /shorts/, /embed/, /live/ — or accepts a bare id. Anything else
 * returns null so the caller can simply not render a player.
 */
export function youTubeId(input: string | null | undefined): string | null {
	if (!input) return null;
	const value = input.trim();
	const isId = (candidate: string | null | undefined) =>
		candidate && /^[\w-]{11}$/.test(candidate) ? candidate : null;

	if (isId(value)) return value;

	let url: URL;
	try {
		url = new URL(value);
	} catch {
		return null;
	}

	if (url.hostname === "youtu.be") return isId(url.pathname.slice(1));
	if (!/(^|\.)youtube(-nocookie)?\.com$/.test(url.hostname)) return null;

	const fromQuery = isId(url.searchParams.get("v"));
	if (fromQuery) return fromQuery;

	// /shorts/ID, /embed/ID, /live/ID, /v/ID
	return isId(url.pathname.split("/")[2]);
}
